import { apiURL, axiosInstance } from "constants/config";
import {
  loadRoundsRequested,
  loadRoundsSuccess,
  loadRoundsFail,
  loadAssignRoundRequested,
  loadAssignRoundSuccess,
  loadAssignRoundFail,
  loadRoundsListRequested,
  loadRoundsListSuccess,
  loadRoundsListFail,
  storeRoundRequested,
  storeRoundSuccess,
  storeRoundFail,
  updateRoundRequested,
  updateRoundSuccess,
  updateRoundFail,
  archiveRoundRequested,
  archiveRoundSuccess,
  archiveRoundFail,
} from "./roundSlice";
import { put, call, takeEvery } from "redux-saga/effects";
import toast from "react-hot-toast";

export function* loadRoundsEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/rounds?SearchValue=${
        action?.payload?.filters?.query ?? ""
      }&PaginationOption.Page=${
        action.payload?.page
      }&PaginationOption.PageSize=${action.payload?.perPage}`
    );
    yield put(loadRoundsSuccess(data));
  } catch (error: any) {
    yield put(loadRoundsFail(error.meessage));
  }
}

export function* loadRoundsListEffect(): Generator<any, void, any> {
  try {
    const { data } = yield call(axiosInstance.get, `${apiURL}/rounds/list`);
    yield put(loadRoundsListSuccess(data));
  } catch (error: any) {
    yield put(loadRoundsListFail(error.meessage));
  }
}

export function* storeRoundEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/rounds`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(storeRoundSuccess(data));
      toast.success("Round created successfully");
    } else {
      toast.error(data?.errors[0]);
    }
  } catch (error: any) {
    yield put(storeRoundFail(error.message));
  }
}

export function* updateRoundEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.put,
      `${apiURL}/rounds/${action.payload?.id}`,
      action?.payload
    );
    if (data?.succeeded) {
      yield put(updateRoundSuccess(data));

      yield call(loadRoundsEffect, {
        payload: { filters: {}, perPage: 10, page: 1 },
        type: "",
      });

      toast.success("Round edited successfully");
    } else {
      toast.error(data?.errors[0]);
    }
  } catch (error: any) {
    yield put(updateRoundFail(error.message));
  }
}
export function* archiveRoundEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { item } = action.payload;

    const { data } = yield call(
      axiosInstance.delete,
      `${apiURL}/rounds/${action.payload?.item?.id}`,
      action.payload?.item
    );
    if (data?.succeeded) {
      yield put(archiveRoundSuccess(data));
      if (item.isActive) {
        toast.success("Round archived successfully");
      } else {
        toast.success("Round unarchived successfully");
      }
      yield call(loadRoundsEffect, {
        payload: { filters: {}, perPage: 10, page: 1 },
        type: "",
      });
    } else {
      toast.error(data?.errors[0]);
    }
  } catch (error: any) {
    yield put(archiveRoundFail(error.message));
  }
}

export function* loadAssignRoundEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/rounds/list?SearchValue=${
        action?.payload?.filters?.query ?? ""
      }&PaginationOption.Page=${
        action?.payload?.page
      }&PaginationOption.PageSize=${action.payload?.perPage}`
    );
    yield put(loadAssignRoundSuccess(data));
  } catch (error: any) {
    yield put(loadAssignRoundFail(error.meessage));
  }
}

export function* roundsSaga(): Generator<any, void, any> {
  yield takeEvery(loadRoundsRequested, loadRoundsEffect);
  yield takeEvery(loadRoundsListRequested, loadRoundsListEffect);
  yield takeEvery(loadAssignRoundRequested, loadAssignRoundEffect);
  yield takeEvery(storeRoundRequested, storeRoundEffect);
  yield takeEvery(updateRoundRequested, updateRoundEffect);
  yield takeEvery(archiveRoundRequested, archiveRoundEffect);
}
